<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      resizable
      size="mini"
      cell-class-name="align-top"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :max-height="500"
    >
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div v-if="row.goodsSize">
            <span class="mr-1">SIZE:</span>
            <span>{{ row.goodsSize }}</span>
          </div>
          <div v-if="row.goodsColor || row.goodsColorEn">
            <span class="mr-1">COLOR:</span>
            <span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div>
            <span class="mr-1">SPU:</span>
            <span>{{ row.amzSpuNo }}</span>
          </div>
          <div>
            <span class="mr-1">SKU:</span>
            <span>{{ row.amzSkuNo }}</span>
          </div>
          <div>
            <span class="mr-1">NC:</span>
            <span>{{ row.ncNo }}</span>
          </div>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-header--column,
  .vxe-body--column {
    background-image: linear-gradient(transparent, transparent),
      linear-gradient(#e8eaec, #e8eaec) !important;
  }
}
</style>
